import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectExpandedFile, selectShowFilesModal } from '@selectors'
import { FILE_MODAL_CLOSE } from '../../redux/actions/types'
import useStyles from './files-modal.style'

import { Video } from '@omnilert/components'
import Modal from '../modal/modal.component'

const FilesModal = () => {
  const expandedFile = useSelector(selectExpandedFile)
  const showFilesModal = useSelector(selectShowFilesModal)

  const dispatch = useDispatch()
  const styles = useStyles()

  const onClose = () => dispatch({ type: FILE_MODAL_CLOSE })

  return (
    <Modal
      cornerButton
      isVisible={showFilesModal}
      onClose={onClose}
    >
      <Video
        className={styles.file}
        media={expandedFile}
      />
    </Modal>
  )
}

export default FilesModal
